module.exports = __webpack_public_path__ + "img/4.0d547072.jpg";